import { isPresent } from '../../group_leader/helpers/value'

// The update_type values v2tournaments#adjust_result writes by; value belongs to match play.
export const FIELDS = Object.freeze({
  rank: 'rank',
  purse: 'purse',
  points: 'points',
  details: 'details',
})

// A cleared position is 999, the engine's "not placed"; 0 would read as a real position.
export const UNPLACED_RANK = '999'

const trimmed = (typed) => String(typed ?? '').trim()

// What the leader typed, ready for adjust_result.
export const submittedValue = (field, typed) => {
  const value = trimmed(typed)
  if (field === FIELDS.details) { return value }
  if (field === FIELDS.rank) { return value === '' ? UNPLACED_RANK : value }
  // A blank purse or points means nothing was awarded, which the engine stores as zero.
  return value === '' ? '0' : value
}

// Rejects what the engine would silently change; blank is how the leader takes an award back.
export const fieldError = (field, typed) => {
  const value = trimmed(typed)
  if (value === '' || field === FIELDS.details) { return null }

  const asNumber = Number(value)
  if (Number.isNaN(asNumber)) { return 'not_a_number' }
  if (field === FIELDS.rank) {
    return (!Number.isInteger(asNumber) || asNumber < 1) ? 'bad_position' : null
  }
  return asNumber < 0 ? 'negative' : null
}

// Two decimals for money and points, as the Adjust screen shows; blank lets the placeholder through.
export const displayValue = (field, value) => {
  if (!isPresent(value) && value !== 0) { return '' }
  if (field === FIELDS.details || field === FIELDS.rank) { return String(value) }
  return Number(value).toFixed(2)
}

export const placedCount = (results) =>
  (results || []).filter((result) => isPresent(result.rank)).length

// The widget lists these games too, which would render each twice.
export const withoutUserScored = (tournaments, userScoredEvents) => {
  const ids = new Set((userScoredEvents || []).map((event) => String(event.event_id)))
  return (tournaments || []).filter((tournament) => !ids.has(String(tournament.id)))
}
